import {useState} from "react";
import ExpenseForm from "./ExpenseForm";
import "./NewExpense.css";
const NewExpense = (props) => {

  const saveExpenseDataHandler = (childExpenseData) => {
    const expenseData = {
      ...childExpenseData,
      id: Math.random().toString(),
    };
    props.onAddExpense(expenseData);
  };
// conditional rendering using props and state
  const [newExpenseBoolean,setExpenseBoolean]=useState(true);
  const expenseBooleanHandler = () =>{
    setExpenseBoolean(!newExpenseBoolean);
  }
  if (newExpenseBoolean) {
    return (
      <div className="new-expense">
        <button onClick={expenseBooleanHandler}>Add New Expense</button>
      </div>
    );
  }
  return (
    <div className="new-expense">
      <ExpenseForm onSaveExpenseData={saveExpenseDataHandler} onClickCancel={expenseBooleanHandler}/>
    </div>
  );
};

export default NewExpense;
